import {
    QuestionAnswer,
    InsertEmoticon,
    Quiz,
    Poll,
    TextFields,
    Cloud,
    Flaky,
    TouchApp,
    Photo, QuestionMark, Mic, FormatListNumbered, PanTool, Link, WbIncandescent
} from "@mui/icons-material";
import toolpress from "../images/home-question-img/toolpress.png"
import altro from "../images/home-question-img/altro.png"
import sendPhoto from "../images/home-question-img/sendPhoto.png"


const questionType = {
    qna: {
        text: 'Q&A',
        icon: <QuestionAnswer/>
    },
    toolpress: {
        text: 'Toolpress',
        icon: <QuestionAnswer/>,
        img: <img src={toolpress} width={'95%'}/>
    },
    quiz: {
        text: 'Quiz',
        icon: <Quiz/>
    },
    poll: {
        text: 'Sondaggio',
        icon: <Poll/>
    },
    reorder: {
        text: 'Riordinamento',
        icon: <FormatListNumbered/>
    },
    wordcloud: {
        text: 'Wordcloud',
        icon: <Cloud/>
    },
    sentiment: {
        text: 'Sentiment',
        icon: <InsertEmoticon/>
    },
    siNo: {
        text: 'Sí/No',
        icon: <Flaky/>
    },
    clickTo:{
        text: 'Click To',
        icon: <TouchApp/>
    },
    links:{
        text: 'Click To',
        icon: <Link />,
    },
    color:{
        text: 'Colora smartphone',
        icon: <WbIncandescent />,
    },
    sendPhoto:{
        text:"Invio foto",
        icon:<Photo/>,
        img: <img src={sendPhoto} width={'95%'}/>
    },
    audio:{
        text:"Invio audio",
        icon:<Mic/>
    },
    reserveSpot: {
        text: "Prenota il tuo posto!",
        icon: <PanTool/>
    },
    altro:{
        text:"Altro",
        icon:<QuestionMark/>,
        img: <img src={altro} width={'95%'}/>
    },
}

export default questionType